export default {
    path: '/publicPage/QRCode',
    name: 'QRCode',
    component: () => import(/* webpackChunkName: "common" */ './QRCode.vue'),
    meta: {
        authPass: true,
        title: '专属二维码',
      headerId: 'myFortune'
    }
};
